import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    IAPIResponse,
    IField,
    INotice,
    ISite,
    ISiteSetting,
    IUmpireUser,
} from "../../types/api";
import { alertActions } from "../alert/alertSlice";
import {
    getSiteSetting,
    getUmpires as getUmpiresFromAPI,
    getNotices as getNoticesFromAPI,
    updateNotice as updateNoticeFromAPI,
    getSites as getSitesFromAPI,
    getFieldsList,
} from "../../lib/api";

export const getUmpires = createAsyncThunk<
    IAPIResponse & {
        umpires: IUmpireUser[];
    },
    void,
    { rejectValue: string }
>("global/getUmpires", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await getUmpiresFromAPI();

        return response;
    } catch (e) {
        const error = e as string;
        // dispatch(
        //     alertActions.error({
        //         level: "danger",
        //         text: "Umpire retrieval failed. Please try again later or contact an admin",
        //         title: error,
        //     }),
        // );
        return rejectWithValue(error);
    }
});

export const getSettings = createAsyncThunk<
    ISiteSetting[],
    void,
    { rejectValue: string }
>("global/getSettings", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await getSiteSetting();

        const settings = Array.isArray(response.setting)
            ? response.setting
            : [response.setting];

        return settings;
    } catch (e) {
        const error = e as string;
        // dispatch(
        //     alertActions.error({
        //         level: "danger",
        //         text: "Settings retrieval failed. Please try again later or contact an admin",
        //         title: error,
        //     }),
        // );
        return rejectWithValue(error);
    }
});

export const getNotices = createAsyncThunk<
    Array<INotice>,
    void,
    { rejectValue: string }
>("global/getNotice", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await getNoticesFromAPI();

        return response.notices;
    } catch (e) {
        const error = e as string;
        return rejectWithValue(error);
    }
});

export const updateNotice = createAsyncThunk<
    INotice | false,
    string,
    { rejectValue: string }
>("global/updateNotice", async (notice, { rejectWithValue, dispatch }) => {
    try {
        const response = await updateNoticeFromAPI(notice);

        dispatch(
            alertActions.success({
                title: "Site notice updated successfully",
                dismissible: true,
            }),
        );

        return response.notice;
    } catch (e) {
        const error = e as string;

        dispatch(
            alertActions.error({
                title: "The server encountered a problem updating the site notice.",
                text: "If the problem continues, please reach out to an admin.",
                dismissible: true,
            }),
        );
        return rejectWithValue(error);
    }
});

export const getSites = createAsyncThunk<
    ISite[],
    void,
    { rejectValue: string }
>("global/getSite", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await getSitesFromAPI();

        return response.sites;
    } catch (e) {
        const error = e as string;
        // dispatch(
        //     alertActions.error({
        //         level: "danger",
        //         text: "Settings retrieval failed. Please try again later or contact an admin",
        //         title: error,
        //     }),
        // );
        return rejectWithValue(error);
    }
});

export const getFields = createAsyncThunk<
    IField[],
    void,
    { rejectValue: string }
>("global/getFields", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await getFieldsList();

        return response.fields;
    } catch (e) {
        const error = e as string;
        // dispatch(
        //     alertActions.error({
        //         level: "danger",
        //         text: "Settings retrieval failed. Please try again later or contact an admin",
        //         title: error,
        //     }),
        // );
        return rejectWithValue(error);
    }
});
